/**
 * @file useHistoryFrom.ts
 * @brief B39: this user's history window start (ISO) or null, from the
 *        cached GET /billing/subscriptions (shared with Billing and the pill).
 */

import { useAuth } from "@/shared/auth/auth-context";
import { useMySubscription } from "@/features/my-billing/api";

export function useHistoryFrom(): string | null {
  const { user } = useAuth();
  const status = useMySubscription();
  if (!user || user.role === "superadmin") return null;
  return status.data?.history?.from ?? null;
}
